import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import Paper from '@material-ui/core/Paper';
import { Row, Col } from 'react-flexbox-grid'
import TextField from '@material-ui/core/TextField';
import MyDialog from '../Layout/myDialog'
import './rubros.css'
import Item from './itemSubRubro'
import { sagaGetSubRubros } from '../../reducers/rubrosReducer/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'


const SubRubroListado = (props) => {
    const dragItem = useRef();
    const dragOverItem = useRef();
    const [itemsSubRubros, setItemsSubRubros] = useState([]);

    React.useEffect(() => {
        setItemsSubRubros(props.rubros.map((x) =>({
            idSubrubro: x.idSubrubro,
            nombre: x.nombre,
            imagen: x.imagen,
            opciones: props.mapToItem(x).opciones,
            activo: x.activo,
            idRubro: x.idRubro
        }))); 
    }, [props.rubros])

    const dragStart = (e, position) => {
        dragItem.current = position;
        //console.log(e.target.innerHTML);
    };
     
    const dragEnter = (e, position) => {
        dragOverItem.current = position;
        //console.log(e.target.innerHTML);
    };
   
    const drop = (e) => {
        const copyListItems = [...itemsSubRubros];
        const dragItemContent = copyListItems[dragItem.current];
        const dragOverItemContent = copyListItems[dragOverItem.current];
        copyListItems.splice(dragItem.current, 1); //se borra
        copyListItems.splice(dragItem.current, 0, dragOverItemContent);
        copyListItems.splice(dragOverItem.current, 1); //se borra
        copyListItems.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;
   
        props.handleOnSwap(
            copyListItems.map(
                (x) => x.idSubrubro.toString()
            ),
            props.rubros[0].idRubro
        )
   
        setItemsSubRubros(copyListItems);
    };
   
        return (
            <>


                {/* menú superior */}
                <TitleBar
                    title={'Subrubros'}
                    newButtonLink={props.newURL}
                    handleOnBack={props.handleOnCancel}
                    showSearch = {false}
                />

                <Paper className='myBox'>
                    <Row>
                        <Col md={6}>
                            <TextField className='myInput'        
                                label='Rubro'
                                name='Rubro'
                                fullWidth
                                value={props.rubroNombre}          
                                InputLabelProps={{
                                    shrink: true,
                                  }}
                            />
                        </Col>

                    </Row>
                </Paper>

                <Row style={{margin: '0px'}} className='draggable'>
                {itemsSubRubros &&
                itemsSubRubros.map((item,index) => (
                    <Col
                        md={6} lg={4}
                        onDragStart={(e) => dragStart(e, index)}
                        onDragEnter={(e) => dragEnter(e, index)}
                        onDragEnd={drop}
                        key={index}
                        className='draggable'
                        draggable>
                           
                        <Item item={item} {...props}></Item>
                    </Col>
                ))}
                </Row>
                {(props.rubros === undefined || props.rubros.length === 0) &&
                    <div className='noRubros'>No se encontraron subrubros activos</div>      
                }
                {
                props.openModal &&
                <MyDialog cuerpo={props.mensaje}  botonConfirmar={props.labelModalOk} handleOnConfirmar={()=>{props.handleModalOk(); setTimeout(props.handleOnSearch, 600);}} handleOnCancelar = {props.handleCloseModal}/>
                }   
               
            </>
        )
}

SubRubroListado.propTypes = {
    rubros: PropTypes.object.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,  
    handleOnSearch : PropTypes.func.isRequired,
    canSwap: PropTypes.bool,
    mensaje: PropTypes.string,
    labelModalOk: PropTypes.string,
    handleModalOk: PropTypes.func,
    handleCloseModal: PropTypes.func,
    openModal: PropTypes.bool,

}

SubRubroListado.defaultProps = {
    rubros: [],
    canSwap: true
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sagaGetSubRubros
    }, dispatch)
}

export default connect(mapDispatchToProps) (SubRubroListado)